module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2RmZmJlZiIgZD0iTTUxMiA2NEE0NDggNDQ4IDAgMSAwIDk2MCA1MTIgNDQ4IDQ0OCAwIDAgMCA1MTIgNjRaTTQyOS4yOCA3MjUuMjhMMjI0IDUyMCAyODAgNDY0bDE0OS4yOCAxNDkuMjhMNzI4IDMxNC43Mmw1NiA1NloiLz48cGF0aCBmaWxsPSIjMDBhOTYyIiBkPSJNNDI5LjI4IDYxMy4yOEwyODAgNDY0IDIyNCA1MjAgNDI5LjI4IDcyNS4yOCA3ODQgMzcwLjcyIDcyOCAzMTQuNzIgNDI5LjI4IDYxMy4yOFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/downloads/icon-success.svg
// module id = 1IcS
// module chunks = 15